<template>
  <section class="hero">
      <div class="hero__content container">
        <div class="hero__content--info">
          <h3 class="hero__uptitle --fade-in-up" data-vertical-ivp-class="--animate">
            FREE E-BOOK
          </h3>
          <h1 class="hero__title --fade-in-up" data-vertical-ivp-class="--animate">
            Optimizing Shareholder Intelligence Through Machine Learning
          </h1>
          <p class="hero__description --fade-in-up --delay-1" data-vertical-ivp-class="--animate">
            In today's financial markets, information is gold. The
            complex maze of shareholder data may seem daunting at
            first, especially to CEOs and CFOs striving to get a
            clearer picture of who's buying, holding, or selling their
            company's stock.
          </p>
          <p class="hero__description --fade-in-up --delay-1" data-vertical-ivp-class="--animate">
            After all, what's the value of a quarterly
            shareholder report when the data is already months old
            by the time it lands on your desk?
          </p>
          <div class="hero__btn --fade-in-up --delay-2" data-vertical-ivp-class="--animate">
            <a href="#form">
              <button class="button">Get the E-Book</button>
            </a>
          </div>
        </div>
        <div class="hero__content--img --fade-in-up" data-vertical-ivp-class="--animate">
          <img src="../assets/hero/ebook.png">
        </div>
      </div>
    </section>
  </template>
  
  <script>

  export default {
    name: 'Hero',
    data () {
      return {
      }
    },
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style lang="scss" scoped>
  @import "../styles/components/hero.scss";
  </style>
  